import { BackArrow } from 'components/svg';
import './premiumBackButton.scss';

export const PremiumBackButton = ({ onClick }: { onClick: () => void }) => (
    <div onClick={onClick} className="premium-back-btn">
        <BackArrow />
    </div>
);
